import * as React from 'react';

function SvgPersonVideo2(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M10 9.05a2.5 2.5 0 100-5 2.5 2.5 0 000 5z' />
			<path d='M2 1a2 2 0 00-2 2v9a2 2 0 002 2h12a2 2 0 002-2V3a2 2 0 00-2-2H2zM1 3a1 1 0 011-1h2v2H1V3zm4 10V2h9a1 1 0 011 1v9c0 .285-.12.543-.31.725C14.15 11.494 12.822 10 10 10c-3.037 0-4.345 1.73-4.798 3H5zm-4-2h3v2H2a1 1 0 01-1-1v-1zm3-1H1V8h3v2zm0-3H1V5h3v2z' />
		</svg>
	);
}

export default SvgPersonVideo2;
